"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const abstract_block_component_1 = require("../abstract-block/abstract-block.component");
const enums_1 = require("../../../@shared-types/print/enums");
let BuildingBlockWrapperComponent = 
// eslint-disable-next-line max-len
class BuildingBlockWrapperComponent extends abstract_block_component_1.AbstractBuildingBlock {
    constructor() {
        super(...arguments);
        this.edit = new core_1.EventEmitter();
        this.moveUp = new core_1.EventEmitter();
        this.moveDown = new core_1.EventEmitter();
        this.delete = new core_1.EventEmitter();
        this.uuid = this.generateUUID();
        this.active = this.activeEditComponent === this.uuid;
        this.editable = false;
        this.emitEdit = () => {
            this.edit.emit({
                block: this.block,
                componentUuid: this.uuid,
            });
        };
        this.emitMoveDown = () => {
            this.moveDown.emit();
        };
        this.emitMoveUp = () => {
            this.moveUp.emit();
        };
        /** Gets called by the `BuildingBlock` component this component
         * wraps around. We will pass the data to the parent component. */
        this.editBlock = (event) => {
            this.edit.emit(event);
        };
        this.deleteBlock = () => {
            this.delete.emit();
        };
    }
    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            // eslint-disable-next-line no-bitwise, no-mixed-operators
            const r = Math.random() * 16 | 0;
            // eslint-disable-next-line no-bitwise, no-mixed-operators
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    ngOnChanges(changes) {
        this.active = false;
        if (changes.activeEditComponent.currentValue === this.uuid) {
            this.active = true;
        }
    }
    ngOnInit() {
        switch (this.block.type) {
            case enums_1.EBuildingBlocks.INPUT:
            case enums_1.EBuildingBlocks.SIGNATURE:
            case enums_1.EBuildingBlocks.TEXT:
            case enums_1.EBuildingBlocks.VEHICLE_FIELD:
            case enums_1.EBuildingBlocks.TITLE:
            case enums_1.EBuildingBlocks.CUSTOMER:
            case enums_1.EBuildingBlocks.OPTIONS:
                this.editable = true;
                break;
            default: break;
        }
    }
};
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockWrapperComponent.prototype, "edit", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockWrapperComponent.prototype, "moveUp", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockWrapperComponent.prototype, "moveDown", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], BuildingBlockWrapperComponent.prototype, "moveLeftRight", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockWrapperComponent.prototype, "delete", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BuildingBlockWrapperComponent.prototype, "activeEditComponent", void 0);
BuildingBlockWrapperComponent = __decorate([
    (0, core_1.Component)({
        selector: 'building-block-wrapper',
        templateUrl: require('./block-wrapper.component.html'),
    })
    // eslint-disable-next-line max-len
], BuildingBlockWrapperComponent);
exports.default = BuildingBlockWrapperComponent;
